import React from 'react';
import NavigationBar from '../navbar/NavigationBar';
import Footer from '../navbar/Footer';
// Import des icônes Material-UI
import PhoneIcon from '@mui/icons-material/Phone';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import WarningIcon from '@mui/icons-material/Warning';
import EmailIcon from '@mui/icons-material/Email';
import LocationOnIcon from '@mui/icons-material/LocationOn';

const PreselectionListPage = () => {

  const pdfUrl = 'https://api.insbu.bi/storage/documents/01KVQKDY3161WHBZZQYJ1T80NN.pdf';

  return (
    <div style={styles.container}>
      <NavigationBar />
      
      <main style={styles.main}>
        {/* En-tête */}
        <header style={styles.header}>
          <div style={styles.projectBanner}>
            <span style={styles.projectTag}>INSBU</span>
            <span style={styles.financeTag}>RPPCUB</span>
          </div>
          
          <h1 style={styles.title}>
            Liste de présélection des agents recenseurs pour le Recensement des Propriétaires des Propriétés/Parcelles dans les centres urbains du Burundi (RPPCUB)
          </h1>
          
          <div style={styles.metaInfo}>
            <span style={styles.date}>Juin 2026</span>
            <span style={styles.location}>Burundi</span>
          </div>
        </header>

        {/* Section 1 : Annonce officielle */}
        <section style={styles.section}>
          <h2 style={styles.sectionTitle}>
            <span style={styles.sectionNumber}>01</span>
            Annonce officielle
          </h2>
          
          <div style={styles.announcementBox}>
            <p style={styles.paragraph}>
              La Direction Générale de l'INSBU informe les personnes dont les noms figurent dans la note de service ci-dessous qu'elles ont été
              présélectionnées pour participer à la formation des candidats agents recenseurs dans le cadre du
              <strong> Recensement des Propriétaires des Propriétés/Parcelles dans les centres Urbains du Burundi (RPPCUB)</strong>.
            </p>
            <p style={styles.paragraph}>
              Les intéressés sont priés de confirmer leurs disponibilités au <strong>22276734</strong>, de <strong>7h à 12h</strong>, du <strong>22 au 26 juin 2026</strong>.
            </p>
            <p style={styles.paragraph}>
              Les lieux et dates de formation leur seront communiqués ultérieurement.
            </p>
          </div>
        </section>

        {/* Section 2 : Liste des candidats présélectionnés (PDF) */}
        <section style={styles.section}>
          <h2 style={styles.sectionTitle}>
            <span style={styles.sectionNumber}>02</span>
            Liste des candidats présélectionnés
          </h2>
          
          <p style={styles.paragraph}>
            La liste complète des personnes présélectionnées est disponible dans la note de service ci-dessous.
            <span style={{ color: '#E30613', fontWeight: 'bold' }}> Veuillez consulter le document pour vérifier votre nom et confirmer votre participation dans les délais indiqués.</span>
          </p>

          {/* Lien de téléchargement / visualisation du PDF */}
          <div style={styles.pdfContainer}>
            <a 
              href={pdfUrl} 
              target="_blank" 
              rel="noopener noreferrer"
              style={styles.pdfButton}
            >
              <PictureAsPdfIcon style={{ marginRight: '12px', fontSize: '1.6rem', verticalAlign: 'middle' }} />
              Télécharger / consulter la liste (PDF)
            </a>
            <p style={styles.pdfHint}>
              Cliquez sur le bouton pour ouvrir la note de service au format PDF. Vous pourrez y consulter la liste complète des présélectionnés.
            </p>
          </div>

          <div style={styles.noteBox}>
            <p style={styles.noteText}>
              <strong>NB :</strong> Si vous avez postulé et que votre nom n'apparaît pas dans la liste, veuillez contacter l'INSBU au numéro indiqué pour toute clarification.
            </p>
          </div>
        </section>

        {/* Section 3 : Instructions de confirmation */}
        <section style={styles.section}>
          <h2 style={styles.sectionTitle}>
            <span style={styles.sectionNumber}>03</span>
            Modalités de confirmation
          </h2>
          
          <div style={styles.confirmationSteps}>
            <div style={styles.stepCard}>
              <div style={styles.stepIcon}>
                <PhoneIcon style={{ fontSize: '2rem', color: '#008D36' }} />
              </div>
              <div>
                <h3 style={styles.stepTitle}>Appelez le 22216734</h3>
                <p style={styles.stepDesc}>Un agent vous prendra en charge pour confirmer votre disponibilité.</p>
              </div>
            </div>
            <div style={styles.stepCard}>
              <div style={styles.stepIcon}>
                <AccessTimeIcon style={{ fontSize: '2rem', color: '#008D36' }} />
              </div>
              <div>
                <h3 style={styles.stepTitle}>Horaires</h3>
                <p style={styles.stepDesc}>De 8h à 12h, du lundi 22 au vendredi 26 juin 2026.</p>
              </div>
            </div>
            <div style={styles.stepCard}>
              <div style={styles.stepIcon}>
                <CalendarTodayIcon style={{ fontSize: '2rem', color: '#008D36' }} />
              </div>
              <div>
                <h3 style={styles.stepTitle}>Formation ultérieure</h3>
                <p style={styles.stepDesc}>Les dates et lieux de formation vous seront communiqués après confirmation.</p>
              </div>
            </div>
          </div>

          <div style={styles.importantBox}>
            <p style={styles.importantText}>
              <WarningIcon style={{ fontSize: '1.2rem', verticalAlign: 'middle', marginRight: '8px' }} />
              <strong>Important :</strong> Seuls les candidats ayant confirmé leur participation seront convoqués à la formation. 
              Passé le délai du 26 juin 2026, aucune confirmation ne sera prise en compte.
            </p>
          </div>
        </section>

        {/* Section 4 : Contact */}
        
      </main>

      <Footer />
    </div>
  );
};

// Styles (avec quelques ajustements pour les icônes)
const styles = {
  container: {
    backgroundColor: '#f5f5f5',
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
  },
  main: {
    flex: 1,
    maxWidth: '1200px',
    margin: '0 auto',
    padding: '20px',
    width: '100%',
  },
  header: {
    textAlign: 'center',
    marginBottom: '50px',
    paddingBottom: '25px',
    borderBottom: `2px solid #008D36`,
  },
  projectBanner: {
    display: 'flex',
    justifyContent: 'center',
    gap: '20px',
    marginBottom: '20px',
  },
  projectTag: {
    backgroundColor: '#E30613',
    color: 'white',
    padding: '8px 20px',
    borderRadius: '20px',
    fontSize: '0.9rem',
    fontWeight: 'bold',
  },
  financeTag: {
    backgroundColor: '#008D36',
    color: '#f5f5f5',
    padding: '8px 20px',
    borderRadius: '20px',
    fontSize: '0.9rem',
    fontWeight: 'bold',
  },
  title: {
    color: '#008D36',
    fontSize: '1.8rem',
    marginBottom: '15px',
    fontWeight: '600',
    lineHeight: 1.3,
    padding: '0 20px',
  },
  metaInfo: {
    display: 'flex',
    justifyContent: 'center',
    gap: '30px',
    marginBottom: '30px',
  },
  date: {
    padding: '8px 20px',
    backgroundColor: '#f0f0f0',
    borderRadius: '20px',
    fontSize: '1rem',
    fontWeight: '500',
  },
  location: {
    padding: '8px 20px',
    backgroundColor: '#f0f0f0',
    borderRadius: '20px',
    fontSize: '1rem',
    fontWeight: '500',
  },
  section: {
    marginBottom: '60px',
    padding: '30px',
    backgroundColor: 'white',
    borderRadius: '8px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
  },
  sectionTitle: {
    color: '#008D36',
    fontSize: '1.8rem',
    marginBottom: '25px',
    display: 'flex',
    alignItems: 'center',
    fontWeight: '600',
  },
  sectionNumber: {
    backgroundColor: '#E30613',
    color: 'white',
    padding: '5px 15px',
    borderRadius: '4px',
    marginRight: '15px',
    fontSize: '1.2rem',
    fontWeight: 'bold',
  },
  paragraph: {
    marginBottom: '20px',
    textAlign: 'justify',
    fontSize: '1.1rem',
    lineHeight: 1.7,
    color: '#333',
  },
  announcementBox: {
    backgroundColor: '#f0f8ff',
    padding: '20px',
    borderRadius: '8px',
    borderLeft: '4px solid #008D36',
    marginBottom: '15px',
  },
  pdfContainer: {
    textAlign: 'center',
    margin: '30px 0',
    padding: '20px',
    backgroundColor: '#f9f9f9',
    borderRadius: '8px',
    border: '1px dashed #008D36',
  },
  pdfButton: {
    display: 'inline-flex',
    alignItems: 'center',
    backgroundColor: '#008D36',
    color: 'white',
    padding: '14px 28px',
    borderRadius: '8px',
    fontSize: '1.1rem',
    fontWeight: 'bold',
    textDecoration: 'none',
    transition: 'background-color 0.3s, transform 0.2s',
    boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
    cursor: 'pointer',
    border: 'none',
    '&:hover': {
      backgroundColor: '#006b2a',
      transform: 'translateY(-2px)',
    },
  },
  pdfHint: {
    marginTop: '15px',
    fontSize: '0.95rem',
    color: '#555',
  },
  noteBox: {
    backgroundColor: '#fff3cd',
    padding: '15px',
    borderRadius: '6px',
    border: '1px solid #ffeeba',
    marginTop: '15px',
  },
  noteText: {
    fontSize: '1rem',
    color: '#856404',
    margin: 0,
  },
  confirmationSteps: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
    gap: '20px',
    marginTop: '20px',
    marginBottom: '30px',
  },
  stepCard: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '15px',
    padding: '20px',
    backgroundColor: '#f9f9f9',
    borderRadius: '8px',
    border: '1px solid #e0e0e0',
  },
  stepIcon: {
    flexShrink: 0,
    marginTop: '2px',
  },
  stepTitle: {
    margin: '0 0 5px 0',
    fontSize: '1.1rem',
    color: '#008D36',
  },
  stepDesc: {
    margin: 0,
    fontSize: '0.95rem',
    color: '#555',
    lineHeight: 1.4,
  },
  importantBox: {
    backgroundColor: '#f8d7da',
    padding: '15px',
    borderRadius: '6px',
    border: '1px solid #f5c6cb',
    marginTop: '15px',
  },
  importantText: {
    margin: 0,
    color: '#721c24',
    fontSize: '1rem',
    display: 'flex',
    alignItems: 'center',
  },
  contactSection: {
    padding: '30px',
    backgroundColor: '#e8f5e9',
    borderRadius: '8px',
    textAlign: 'center',
    border: '1px solid #008D36',
    marginBottom: '40px',
  },
  contactTitle: {
    color: '#008D36',
    fontSize: '1.6rem',
    marginBottom: '15px',
    fontWeight: '600',
  },
  contactText: {
    fontSize: '1.05rem',
    lineHeight: 2,
    color: '#333',
  },
};

export default PreselectionListPage;